import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../slices/apiSlice";
import loginSlice from "../slices/Loginxxx/loginSlice";
import errorsSlice from "../slices/Errorsxx/errorsSlice";
import trkgfileSlice from "../slices/Trkgfile/trkgfileSlice";
import autocomSlice from "../slices/autocomxSlice/autocomSlice";
import { cimaxxxxApiSlice } from "../slices/Cimaxxxx/cimaxxxxApiSlice";
import cimaxxxSlice from "../slices/Cimaxxxx/cimaxxxxSlice";

//Redux persist
import storageSession from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";

const persistConfig = {
  key: "login",
  storage: storageSession,
  // infoUser y permUser se persisten para que el iframe del visor (Panelvis) no
  // tenga que volver a pedir /userinfo al montarse: App bloquea todo el render
  // con isHydrating hasta que esa peticion responda, y el documento no se veia.
  whitelist: ["token", "user", "isLoggedIn", "infoUser", "permUser"],
};

const persistedReducer = persistReducer(persistConfig, loginSlice);

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [cimaxxxxApiSlice.reducerPath]: cimaxxxxApiSlice.reducer,
    persistedReducer,
    errors: errorsSlice,
    trkgfile: trkgfileSlice,
    autocomp: autocomSlice,
    cimaxxxx: cimaxxxSlice,
  },
  devTools: process.env.REACT_APP_GESTOR_DEBUG,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(apiSlice.middleware, cimaxxxxApiSlice.middleware),
});

export const persistor = persistStore(store);
